module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/categoryIcons/nfl/icons_receiving_tds/green-4b27a46042b0ce03e54e6104e561e882.svg";